export const pages = ['index', 'vue', 'reactjs'];
